<template>
  <div class="login-page">
    <invite-view v-if="isInviteView" />
    <template v-else>
      <div class="normal-view">
        <wb-logo :cssStyle="{ padding: '64px 0 40px' }" />
        <login-view  :channelCode="channelCode"/>
      </div>
    </template>
  </div>
</template>

<script>
  import WbLogo from '@/components/wb-logo.vue'
  import IpUtil from '@/utils/ipUtil.js'
  import i18n from '@/language'
  import LoginHelper from './login-helper'
  import LoginView from './login-view.vue'
  import InviteView from './invite-view.vue'
  import { getUrlParamByName } from '@/utils/common'

  export default {
    name: 'login-index',

    components: { WbLogo, LoginView, InviteView },

    data() {
      return {
        isInviteView: false, // 是否是邀请view
        channelCode: ''// 渠道码
      }
    },

    mounted() {
      this.initLoginHelper()
      this.initPageLang()
      this.getChannelCode()
    },

    methods: {
      // 获取当前语言
      async initPageLang() {
        let langKey = await IpUtil.getLangFromLocation()
        if (window.location.href.indexOf('lang=') !== -1) {
          langKey = getUrlParamByName('lang')
        }
        this.$i18n.locale = langKey
        document.title = i18n.t('router.winbull')
      },

      initLoginHelper() {
        LoginHelper.initLoginParams()
        this.isInviteView = !!LoginHelper.activityUserId
      },

      getChannelCode() {
        if (window.location.href.indexOf('key=') !== -1) {
          this.channelCode = getUrlParamByName('key')
        } else {
          this.channelCode = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-page {
    .normal-view {
      min-height: 100vh;
      background: #fff;
      padding: 0 40px;
    }
  }
</style>
